import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "staffRequired", "roleCheckbox", "roleCount", "roleHidden", "roleError"]

  static values = {
    minCountError: { type: String, default: "Staff count must be at least 1" }
  }

  connect() {
    this.updateTotalStaffRequired()
  }

  toggleRole(event) {
    const checkbox = event.currentTarget
    const roleId = checkbox.dataset.roleId
    const checked = checkbox.checked

    const countInput = document.getElementById(`shift_medical_role_count_${roleId}`)
    const priorityInput = document.getElementById(`shift_medical_role_priority_${roleId}`)
    const errorDiv = document.getElementById(`role_error_${roleId}`)

    if (checked) {
      countInput.disabled = false
      countInput.classList.remove('opacity-50')
      if (priorityInput) { priorityInput.disabled = false; priorityInput.classList.remove('opacity-50') }
    } else {
      countInput.disabled = true
      countInput.classList.add('opacity-50')
      if (priorityInput) { priorityInput.disabled = true; priorityInput.classList.add('opacity-50') }
      errorDiv.classList.add('hidden')
      errorDiv.textContent = ''
    }

    this.updateTotalStaffRequired()
  }

  validateCount(event) {
    const input = event.currentTarget
    const roleId = input.dataset.roleId
    const value = parseInt(input.value, 10)
    const errorDiv = document.getElementById(`role_error_${roleId}`)

    if (isNaN(value) || value < 1) {
      errorDiv.textContent = this.minCountErrorValue
      errorDiv.classList.remove('hidden')
      input.classList.add('border-red-500')
      input.classList.remove('border-gray-300')
    } else {
      errorDiv.classList.add('hidden')
      errorDiv.textContent = ''
      input.classList.remove('border-red-500')
      input.classList.add('border-gray-300')
    }

    this.updateTotalStaffRequired()
  }

  selectAll() {
    this.containerTarget.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = true
      const roleId = checkbox.dataset.roleId
      const countInput = document.getElementById(`shift_medical_role_count_${roleId}`)
      const priorityInput = document.getElementById(`shift_medical_role_priority_${roleId}`)

      countInput.disabled = false
      countInput.classList.remove('opacity-50')
      if (priorityInput) { priorityInput.disabled = false; priorityInput.classList.remove('opacity-50') }
    })

    this.updateTotalStaffRequired()
  }

  clearAll() {
    this.containerTarget.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false
      const roleId = checkbox.dataset.roleId
      const countInput = document.getElementById(`shift_medical_role_count_${roleId}`)
      const priorityInput = document.getElementById(`shift_medical_role_priority_${roleId}`)
      const errorDiv = document.getElementById(`role_error_${roleId}`)

      countInput.disabled = true
      countInput.classList.add('opacity-50')
      if (priorityInput) { priorityInput.disabled = true; priorityInput.classList.add('opacity-50') }
      errorDiv.classList.add('hidden')
      errorDiv.textContent = ''
    })

    this.updateTotalStaffRequired()
  }

  updateTotalStaffRequired() {
    let total = 0
    this.containerTarget.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
      const roleId = checkbox.dataset.roleId
      const countInput = document.getElementById(`shift_medical_role_count_${roleId}`)
      const value = parseInt(countInput.value, 10)
      if (!isNaN(value) && value > 0) {
        total += value
      }
    })

    if (this.hasStaffRequiredTarget) {
      this.staffRequiredTarget.value = total > 0 ? total : 1
    }
  }
}
